import { Serializable } from './commom/serializable';

export class EmpresaUsuario implements Serializable<EmpresaUsuario> {
    public CnpjEmpresaUsuario: string;
    public NomeEmpresaUsuario: string;   
        

    deserialize(input: Object): EmpresaUsuario {
        Object.assign(this, input);

        return this;
    }
}


// WEBPACK FOOTER //
// ./src/entities/empresa-usuario.ts